import React from 'react';
import { formatPhoneNumberIntl } from 'react-phone-number-input';

import { MCButton, Avatar, View, PopoverMenu } from 'src/components/basic';
import { TableLibrary } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';

import {
  remCss,
  permissions,
  withRouter,
  userFullName,
  scssVariables as variables
} from 'src/helpers';

import model from './model';
import LANG_CONST from 'src/helpers/lang/const';

function formatEarnings(val, currency) {
  if (!val) return `0 ${currency}`;
  if (val.toString().split('.')[1]?.length > 2) {
    return val.toFixed(2) + ' ' + currency;
  } else {
    return val + ' ' + currency;
  }
}

class AllStatsClinics extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    if (!model.initFlag) {
      model.refresh();
      model.initFlag = true;
    }
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.initFlag = false;
  }

  prevWeek = () => {
    console.log('prevWeek');
    let startDate = model.input('startDate').clone();
    let newStartDate = startDate.clone().startOf('isoWeek').subtract(1, 'week');
    let newEndDate = newStartDate.clone().add('1', 'week');
    model.setState({ startDate: newStartDate, endDate: newEndDate });
    model.refresh();
  };

  nextWeek = () => {
    console.log('nextWeek');
    let endDate = model.input('endDate').clone();
    let newStartDate = endDate.startOf('isoWeek');
    let newEndDate = newStartDate.clone().add(1, 'week');
    model.setState({ startDate: newStartDate, endDate: newEndDate });
    model.refresh();
  };

  render() {
    let loading = model.refreshing();
    let noResults = model.noResults();
    let searchQuery = model.listInput('search');
    let items = model.items();
    let currency = model.getCurrency();

    const columns = [
      {
        label: 'Info',
        // sort: { sortKey: 'email' },
        resize: true,
        width: `${remCss(280)}px`,
        // minWidth: 'remCss(210)',
        renderCell: (item) => (
          <div className='mc-flex-10' style={{ alignItems: 'flex-start' }}>
            <div style={{ marginRight: 4 }}>
              <Avatar text={userFullName(item)} width={50} height={50} image={item.avatar} />
            </div>
            <div className={'mc-flex-5-col'}>
              <div className={'mc-value-518 mc-value-truncate'}>
                {item.firstName} {item.lastName}
              </div>
              <div className={'mc-value-518 mc-value-truncate'}>{item.email}</div>
              <div className={'mc-value-418 mc-value-truncate'}>
                <span style={{ position: 'relative', top: 4 }}>
                  <SVGIcon width={20} iconname={'phone-icon'} />
                </span>
                {formatPhoneNumberIntl((item.phoneNumber || '').toString())}
              </div>
            </div>
          </div>
        ),
        footer: loading
          ? null
          : () => (
              <div style={{ textAlign: 'right' }}>
                <div>appointments:</div>
                <div>tickets:</div>
                <div>treatments:</div>
              </div>
            )
        // renderCell: (item) => {
        //   return (
        //     <ShortInfo
        //       user={item}
        //       specialist={[]}
        //       to={permissions.PAGES.ADMIN_MESSAGES_USER_PAGE.match(item.id)}
        //     />
        //   );
        // }
      },
      {
        label: 'Today',
        resize: true,
        // minWidth: '80',
        renderCell: (item) => (
          <div className={'mc-flex-5-col'}>
            <div className={'mc-value-518 mc-value-truncate'}>
              appointments: {item.today_appointment} /{' '}
              {formatEarnings(item.today_appointmentEarnings, currency)}
            </div>
            <div className={'mc-value-418 mc-value-truncate'}>
              tickets: {item.today_ticket} / {formatEarnings(item.today_ticketEarnings, currency)}
            </div>
            <div className={'mc-value-418 mc-value-truncate'}>
              treatments: {item.today_treatment}
            </div>
          </div>
        ),
        footer: loading
          ? null
          : () => (
              <div>
                <div>
                  {model.getTotalData('today', 'appointment')} /{' '}
                  {model.getTotalData('today', 'appointmentEarnings')} {currency}
                </div>
                <div>
                  {model.getTotalData('today', 'ticket')} /{' '}
                  {model.getTotalData('today', 'ticketEarnings')} {currency}
                </div>
                <div>{model.getTotalData('today', 'treatment')}</div>
              </div>
            )
      },
      {
        label: 'Yesterday',
        resize: true,
        // minWidth: '80',
        renderCell: (item) => (
          <div className={'mc-flex-5-col'}>
            <div className={'mc-value-518 mc-value-truncate'}>
              {item.yesterday_appointment} /{' '}
              {formatEarnings(item.yesterday_appointmentEarnings, currency)}
            </div>
            <div className={'mc-value-418 mc-value-truncate'}>
              {item.yesterday_ticket} / {formatEarnings(item.yesterday_ticketEarnings, currency)}
            </div>
            <div className={'mc-value-418 mc-value-truncate'}>{item.yesterday_treatment}</div>
          </div>
        ),
        footer: loading
          ? null
          : () => (
              <div>
                <div>
                  {model.getTotalData('yesterday', 'appointment')} /{' '}
                  {model.getTotalData('yesterday', 'appointmentEarnings')} {currency}
                </div>
                <div>
                  {model.getTotalData('yesterday', 'ticket')} /{' '}
                  {model.getTotalData('yesterday', 'ticketEarnings')} {currency}
                </div>
                <div>{model.getTotalData('yesterday', 'treatment')}</div>
              </div>
            )
      },
      {
        label: 'Last Week',
        resize: true,
        // minWidth: '80',
        renderCell: (item) => (
          <div className={'mc-flex-5-col'}>
            <div className={'mc-value-518 mc-value-truncate'}>
              {item.week_appointment} / {formatEarnings(item.week_appointmentEarnings, currency)}
            </div>
            <div className={'mc-value-418 mc-value-truncate'}>
              {item.week_ticket} / {formatEarnings(item.week_ticketEarnings, currency)}
            </div>
            <div className={'mc-value-418 mc-value-truncate'}>{item.week_treatment}</div>
          </div>
        ),
        footer: loading
          ? null
          : () => (
              <div>
                <div>
                  {model.getTotalData('week', 'appointment')} /{' '}
                  {model.getTotalData('week', 'appointmentEarnings')} {currency}
                </div>
                <div>
                  {model.getTotalData('week', 'ticket')} /{' '}
                  {model.getTotalData('week', 'ticketEarnings')} {currency}
                </div>
                <div>{model.getTotalData('week', 'treatment')}</div>
              </div>
            )
      },
      {
        label:
          model.input('startDate').format('D MMM') + ' - ' + model.input('endDate').format('D MMM'),
        resize: true,
        // width: '10%',
        width: `${remCss(160)}px`,
        renderCell: (item) => (
          <div className={'mc-flex-5-col'}>
            <div className={'mc-value-518 mc-value-truncate'}>
              {item.between_appointment} /{' '}
              {formatEarnings(item.between_appointmentEarnings, model.getCurrency())}
            </div>
            <div className={'mc-value-418 mc-value-truncate'}>
              {item.between_ticket} /{' '}
              {formatEarnings(item.between_ticketEarnings, model.getCurrency())}
            </div>
            <div className={'mc-value-418 mc-value-truncate'}>{item.between_treatment}</div>
          </div>
        ),
        footer: loading
          ? null
          : () => (
              <div>
                <div>
                  {model.getTotalData('between', 'appointment')} /{' '}
                  {model.getTotalData('between', 'appointmentEarnings')} {currency}
                </div>
                <div>
                  {model.getTotalData('between', 'ticket')} /{' '}
                  {model.getTotalData('between', 'ticketEarnings')} {currency}
                </div>
                <div>{model.getTotalData('between', 'treatment')}</div>
              </div>
            )
      },
      {
        label: 'Actions',
        cellStyles: {
          alignItems: 'flex-start',
          textAlign: 'end'
        },
        width: `${remCss(120)}px`,
        renderCell: (item) => {
          const paid = item.between_paid;
          let isDone = false;
          if (!item.between_earnings) isDone = true;
          return (
            <div className={'mc-flex-10-col'} style={{ alignItems: 'flex-end' }}>
              <MCButton
                label={'Login'}
                small
                radius
                primary
                dark
                style={{ width: remCss(95) }}
                onClick={() => {
                  permissions.switchToFront();
                  model.sublogin(item);
                }}
              />
              <View style={{ flexDirection: 'row', width: remCss(95), gap: remCss(5) }}>
                <MCButton
                  label={isDone ? LANG_CONST.zero : paid ? LANG_CONST.paid : LANG_CONST.buttons.pay}
                  primary
                  small
                  radius
                  dark={!isDone}
                  light={isDone}
                  flex
                  onClick={
                    paid || isDone
                      ? undefined
                      : () => {
                          model.actions(item, 'pay');
                        }
                  }
                />
                {paid && !isDone && (
                  <View>
                    <PopoverMenu
                      triggerOffset={5}
                      arrowOffset={-30}
                      placement={'bottom-end'}
                      popupMenuStyle={{}}
                      menu={(close) => (
                        <>
                          <MCButton
                            label={LANG_CONST.buttons.unpay}
                            disabled={!paid}
                            primary
                            radius
                            small
                            outline
                            onClick={() => {
                              close();
                              model.actions(item, 'unpay');
                            }}
                          />
                        </>
                      )}
                      className={'mc-pointer mc-flex mc-flex-center'}
                    >
                      {(isOpen, toggle) => (
                        <MCButton primary tiny outline radius hover onClick={toggle}>
                          <span
                            className={'mc-rotate ' + (isOpen ? 'mc-rotate-180' : '')}
                            style={{ height: remCss(33), width: remCss(33) }}
                          >
                            <SVGIcon
                              iconname={BASE_ICONS.DOWN}
                              width={33}
                              padding={5}
                              fill={variables['colors-mc-primary']}
                            />
                          </span>
                        </MCButton>
                      )}
                    </PopoverMenu>
                  </View>
                )}
              </View>
            </div>
          );
        }
      }
    ];

    return (
      <div className={'mc-container-content__body'}>
        <div className={'mc-container-content__body-content'} style={{ marginTop: remCss(25) }}>
          <TableLibrary
            loading={loading}
            noResults={noResults}
            searchQuery={searchQuery}
            sortBy={model.state.sortBy}
            showPagination={false}
            // selectedPage={model.state.pageIndex}
            // total={total}
            // limit={model.listLimit}
            onSortChange={(sortBy) => {
              model.handleChange('sortBy', sortBy);
              model.setListState({ items: [] }, model.getCurrentId(), null, true);
              model.loadMore();
            }}
            // onSetPage={(v) => {
            //   model.handleChange('pageIndex', v);
            //   model.setListState({ items: [] }, model.getCurrentId(), null, true);
            //   model.loadMore();
            // }}
            columns={columns}
            data={items}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(AllStatsClinics);
